import { useState } from "react";
import { faqs } from "@/mocks/comics";

const faqLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-20 py-14 md:py-20">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqLd) }}
      />
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-8 lg:grid-cols-[320px_1fr]">
          <div>
            <p className="mb-2 inline-flex items-center gap-2 text-xs font-medium tracking-widest text-secondary-700">
              <span className="h-px w-6 bg-secondary-500"></span>
              常见问题
            </p>
            <h2 className="text-2xl md:text-4xl">补档前，先看这里</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              关于年代划分、考古范围、绝版求补和清晰度，常见疑问都整理在这一栏。
            </p>
            <a
              href="#contribute"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-secondary-300 bg-secondary-100 px-5 py-2.5 text-sm font-medium text-secondary-900 transition-colors hover:bg-secondary-200"
            >
              没找到答案？去投稿区聊聊
              <i className="ri-message-3-line"></i>
            </a>
          </div>

          <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={f.q}>
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-primary-50 md:px-6"
                  >
                    <span className="text-sm font-medium text-foreground-900 md:text-base">{f.q}</span>
                    <i
                      className={`ri-add-line shrink-0 text-lg text-primary-700 transition-transform ${
                        isOpen ? "rotate-45" : ""
                      }`}
                    ></i>
                  </button>
                  {isOpen && (
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600 md:px-6">
                      {f.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}